<template>
  <v-row class="bg-image" no-gutters>
    <v-card
      class="main-card mx-auto pa-5"
      :class="{
        'pa-5 mobile-main-card': $vuetify.breakpoint.smAndDown,
      }"
    >
        <v-card-title class="pa-0">
          <span class="font-weight-bold main-heading">
            Reset Password!
          </span>
        </v-card-title>
        <v-card-title class="pa-0">
          <span class="default-font text-wrapping caption">
            Welcome! reset your password
          </span>
        </v-card-title>
        <v-card-text class="pa-0 mt-6">
          <v-form
            class="mt-10"
            ref="form"
            lazy-validation
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="email"
              placeholder="Enter your email"
              color="#434343"
              :prepend-inner-icon="'mdi-email'"
              name="email"
              class="login-field-button"
              outlined
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="password"
              placeholder="Enter Your Password"
              :prepend-inner-icon="'mdi-lock'"
              outlined
              color="#434343"
              class="login-field-button"
              required
              counter
              @click:append="show = !show"
              :rules="[
                rules.required,
                rules.passwordNumber,
                rules.passwordAlphabet,
                rules.passwordSpecial,
                rules.passwordLength,
              ]"
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              name="password"
              placeholder="Enter Password Confirmation"
              color="#434343"
              :prepend-inner-icon="'mdi-lock'"
              class="login-field-button"
              outlined
              counter
              @click:append="show1 = !show1"
              :rules="[
                rules.required,
                rules.passwordNumber,
                rules.passwordAlphabet,
                rules.passwordSpecial,
                rules.passwordLength,
              ]"
            ></v-text-field>
            <div class="text-center">
              <v-btn
                class="mt-5 mb-8 adjust-btn-register"
                type="submit"
                large
                :loading="loader"
                :disabled="loader"
                @click="onSubmit"
              >
                Reset Password
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
        <v-card-text class="px-0">
          <p class="text-left caption footer">
            <a class="appGray--text"
                >Privacy &nbsp; | &nbsp; Terms & Condition</a
            >
          </p>
        </v-card-text>
      </v-card>
    </v-row>
</template>

<script>
import { showSnackbar } from "../utils/GlobalActions";
export default {
  name: "SignIn",
  components: {},
  data() {
    return {
      snackbarSuccess: false,
      successText: "",
      errorText: "",
      snackbarError: false,
      loader: false,
      show: false,
      show1: false,
      password: "",
      email: "",
      confirmPassword: "",
      rules: {
        required: (value) => !!value || "This field is required",
        // emptyPassword: (value) =>
        //   /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{7,}$/.test(value) ||
        //   "Minimum 7 character required",
        passwordLength: (value) =>
          /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{8,}$/.test(value) ||
          "Minimum 8 character required ",
        passwordNumber: (value) =>
          // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(value) ||
          /^(?=.*[0-9])/.test(value) || "Must contain at least 1 number",
        passwordAlphabet: (value) =>
          /^(?=.*[a-zA-Z])/.test(value) || "Must contain at least 1 alphabet",
        passwordSpecial: (value) =>
          /^(?=.*[!@#\$%\^&\*\)\(+=._-])/.test(value) ||
          "Must contain at least 1 special character",
      },
    };
  },
  beforeMount() {
    this.email = this.$route.params.email;
    console.log(this.$route.params, "l")
  },

  methods: {
    onSubmit() {
      this.loader = true;
      if (this.$refs.form.validate()) {
        if(this.password!= this.confirmPassword){

          showSnackbar("Error!", "Password Does not match","error");
        }
        else{
        this.$store
          .dispatch("resetPassword", {
            email: this.email,
            password: this.password,
            confirm_password: this.confirmPassword,
            token: this.$route.params.token,
          })
          .then((res) => {
            this.loader = false;
            showSnackbar("Success!","Your Password has been changed","success");
            setTimeout(() => {
                  // router.push({ name: "signin" });
                  this.$router.push({ name: "signin" });
                }, 2000);
            
          })
          .catch((err) => {
            this.loader = false;
         showSnackbar("Error!",err.response.data,"error");
            
          });
        }
      } else {
        this.loader=false;
        showSnackbar("Error!", "All fields are required","error");
      }
    },
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.adjust-form-heading {
  font-size: 28px;
}
.adjust-background-1 {
  min-height: 350px;
  /* background: rgb(46, 173, 123); */
  background: #434343;
  clip-path: polygon(0 0, 100% 0%, 100% 99%, 0 84%);

  /* clip-path: polygon(0 1%, 100% 0%, 100% 76%, 0% 100%); */
}
.signin {
  max-width: 559px;
  min-height: 400px;
  box-sizing: border-box;
  box-shadow: none !important;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  background: white;
  top: 100px;
}
.section-container {
  max-width: 100%;
}
.v-application .pa-5 {
  padding: 50px !important;
  padding-top: 25px !important;
}

.left {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2ead7b;
  color: #fff;
  box-sizing: border-box;
}
.right h2 {
  text-align: center;
  margin: 30px 0;
}
.signin-btn {
  width: 70%;
}
.section-container {
  position: relative;
}
</style>
<style >
.login-field-button .v-icon {
  color: #8692a6 !important;
  margin-bottom: 10px;
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
  margin-top: 18px;
}
.adjust-forgot-btn {
  background: #c6c1e4 !important;
  color: white !important;
}
.adjust-btn-register {
  width: 100% !important;
  height: 38px !important;
  background: #161c27 !important;
  color: white !important;
  border-radius: 7px;
}
.main-card {
  width: 446px;
  height: 480px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  margin-top: 12%;  
  position: relative;
  right: 24%;
}
.bg-image {
  background: url('../assets/login-bg-web.svg');
  height: 100%;
  background-size: cover;
}
@media only screen and (max-width: 1024px) {
  .main-card {
    width: 370px;
    height: 460px;
    margin-top: 25%;  
    position: relative;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    right: 0%;
  }
  .bg-image {
    background: url('../assets/login-bg.svg');
    height: 100%;
    background-size: cover;
  }
}
</style>